import { useEffect } from 'react';
import { useAnalytics } from '../utils/setup/analytics-setup';

function usePageview(name) {
  const { analyticsPageView } = useAnalytics();

  useEffect(() => {
    analyticsPageView(name);
  }, [name]);
}

export { usePageview };
